import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient, restoreQueryClient } from "./persistQueryClient";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - données considérées fraîches
      gcTime: 24 * 60 * 60 * 1000, // Garder en cache 24 heures (pour offline)
      refetchOnWindowFocus: false, // Ne pas refetch quand on revient sur l'onglet
      retry: 2, // Retry 2 fois en cas d'erreur
      retryDelay: 1000, // 1 seconde de delay entre les tentatives
    },
    mutations: {
      retry: false, // Pas de retry pour les mutations (on gère le mode offline manuellement)
    },
  },
});

// Restaurer le cache au démarrage
restoreQueryClient(queryClient);

// Sauvegarder le cache périodiquement
persistQueryClient(queryClient);
